/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, ViewEncapsulation } from '@angular/core';
export class NotFound {
public isSelectOptGroup = false;
public isSelectOption = false;
public isNotFound = true;
public disabled = true;
constructor() {

    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-not-found',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NotFound_tsickle_Closure_declarations() {
/** @type {?} */
NotFound.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotFound.ctorParameters;
/** @type {?} */
NotFound.prototype.isSelectOptGroup;
/** @type {?} */
NotFound.prototype.isSelectOption;
/** @type {?} */
NotFound.prototype.isNotFound;
/** @type {?} */
NotFound.prototype.disabled;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
